import { render } from "./global-payment-methods-list.vue?vue&type=template&id=a485944e&ts=true"
import script from "./global-payment-methods-list.ts?vue&type=script&lang=ts"
export * from "./global-payment-methods-list.ts?vue&type=script&lang=ts"

import "./global-payment-methods-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__